var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.parameters),function(param){return _c('tag',{key:param._id,attrs:{"text":_vm.generateHighlightText(param),"background-color":"indigo lighten-5","normal-size":true,"no-ripple":true,"color":"primary"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }